import { useTranslation } from 'react-i18next';

export function AppErrorFallback() {
  const { t } = useTranslation('common');
  return (
    <div role="alert" className="app-error-fallback">
      <h1>{t('error.title')}</h1>
      <p>{t('error.body')}</p>
      <button type="button" onClick={() => window.location.reload()}>
        {t('retry')}
      </button>
    </div>
  );
}
